<svg width="18" height="25" viewBox="0 0 18 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3.97949" y="4.5" width="9.18367" height="16" fill="#3B7DD8"/>
<path d="M13.1633 20.5V24.5H0L6.2395e-06 4.5H3.9796V20.5H13.1633Z" fill="#64A1F4"/>
<path d="M17.1428 20.5H13.1632V4.5L3.97949 4.5L3.97949 0.5L17.1428 0.5L17.1428 20.5Z" fill="#FFC53D"/>
</svg>
